<div class="container-fluid p-4">
  <!-- Page Header -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h1 class="page-title mb-1">Dashboard</h1>
      <p class="page-subtitle mb-0">Welcome back, {{account?.firstName || 'User'}}!</p>
    </div>
  </div>

  <!-- Stat Cards Row (Admin/Employee view) -->
  <div class="row g-4 mb-4" *ngIf="account?.role === 'Admin' || account?.role === 'Employee'">
    <div class="col-md-6 col-lg-3">
      <div class="stat-card">
        <div class="stat-icon" style="background: #2563EB;">
          <i class="fa fa-users"></i>
        </div>
        <div>
          <p class="stat-label">Total Dealers</p>
          <h3 class="stat-value">{{dealerCount || '--'}}</h3>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-3">
      <div class="stat-card">
        <div class="stat-icon" style="background: #16A34A;">
          <i class="fa fa-certificate"></i>
        </div>
        <div>
          <p class="stat-label">Certificates Issued</p>
          <h3 class="stat-value">--</h3>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-3">
      <div class="stat-card">
        <div class="stat-icon" style="background: #D97706;">
          <i class="fa fa-clock"></i>
        </div>
        <div>
          <p class="stat-label">Pending</p>
          <h3 class="stat-value">--</h3>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-3">
      <div class="stat-card">
        <div class="stat-icon" style="background: #7C3AED;">
          <i class="fa fa-indian-rupee-sign"></i>
        </div>
        <div>
          <p class="stat-label">Revenue (MTD)</p>
          <h3 class="stat-value">--</h3>
        </div>
      </div>
    </div>
  </div>

  <!-- Dealer view stat cards -->
  <div class="row g-4 mb-4" *ngIf="account?.role === 'Dealer'">
    <div class="col-md-6 col-lg-4">
      <div class="stat-card">
        <div class="stat-icon" style="background: #2563EB;">
          <i class="fa fa-wallet"></i>
        </div>
        <div>
          <p class="stat-label">Account Balance</p>
          <h3 class="stat-value">{{dealer?.dealerBalance ? '₹' + dealer.dealerBalance : '--'}}</h3>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4">
      <div class="stat-card">
        <div class="stat-icon" style="background: #16A34A;">
          <i class="fa fa-certificate"></i>
        </div>
        <div>
          <p class="stat-label">Certificates Issued</p>
          <h3 class="stat-value">--</h3>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4">
      <div class="stat-card">
        <div class="stat-icon" style="background: #D97706;">
          <i class="fa fa-clock"></i>
        </div>
        <div>
          <p class="stat-label">Pending Certificates</p>
          <h3 class="stat-value">--</h3>
        </div>
      </div>
    </div>
  </div>

  <!-- Quick Actions -->
  <div class="content-card mb-4">
    <div class="card-section-header">
      <h5><i class="fa fa-bolt me-2"></i>Quick Actions</h5>
    </div>
    <div class="card-section-body">
      <div class="row g-3">
        <div class="col-auto" *ngIf="account?.role !== 'Dealer'">
          <a routerLink="/users" class="btn btn-outline-primary">
            <i class="fa fa-users me-2"></i>Manage Users
          </a>
        </div>
        <div class="col-auto">
          <a routerLink="/issueCertificate" class="btn btn-primary">
            <i class="fa fa-plus me-2"></i>Issue Certificate
          </a>
        </div>
        <div class="col-auto">
          <a routerLink="/reports" class="btn btn-outline-primary">
            <i class="fa fa-chart-bar me-2"></i>View Reports
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
